import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6484e482"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Anzahl"),
    /*#__PURE__*/_createElementVNode("th", null, "Produkt"),
    /*#__PURE__*/_createElementVNode("th", null, "Unternehmen")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "LEI Registrierung", -1))
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Oder", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Hinweise zur Datenverwendung", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Ihre Daten werden ohne Ihre ausdrückliche Einwilligung nur zum Zweck der Vertragsabwicklung und Kundenbetreuung verwendet. Weiterführende Informationen zum Datenschutz entnehmen Sie bitte unseren "),
  /*#__PURE__*/_createElementVNode("a", { href: "" }, "ausführlichen Datenschutzhinweisen"),
  /*#__PURE__*/_createTextVNode(".")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _hoisted_1,
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, _toDisplayString(_ctx.counter), 1),
          _hoisted_2,
          _createElementVNode("td", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company, (item) => {
              return (_openBlock(), _createElementBlock("ul", { key: item }, [
                _createElementVNode("li", null, _toDisplayString(item), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_button, {
        title: 'Zurück',
        onClick: _ctx.backToParent
      }, null, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        title: 'Zur Kasse',
        onClick: _ctx.submitResult
      }, null, 8, ["onClick"])
    ]),
    _hoisted_4,
    _createVNode(_component_base_button, {
      title: 'Weitere lei registrieren',
      onClick: _ctx.anotherOne
    }, null, 8, ["onClick"]),
    _hoisted_5,
    _hoisted_6
  ], 64))
}